// Mirrors COMMON_PASSWORDS in qerchabackend/utils/passwordPolicy.js. A backend test keeps the two lists identical.
export const COMMON_PASSWORDS = new Set([
  'password', 'password1', 'password12', 'password123', 'passw0rd', 'p@ssword', 'p@ssw0rd', 'qwerty', 'qwerty123',
  'qwertyuiop', 'qwerty1234', 'letmein', 'letmein1', 'welcome', 'welcome1', 'iloveyou', 'monkey', 'dragon',
  'football', 'baseball', 'master', 'shadow', 'sunshine', 'princess', 'trustno1', 'abc123', 'abcd1234', 'abc12345',
  '123456', '1234567', '12345678', '123456789', '1234567890', '12345678910', '111111', '11111111', '00000000',
  '123123123', '987654321', 'iloveyou1', 'admin', 'admin123', 'administrator', 'login', 'changeme', 'changeme1',
  'secret', 'secret1', 'qazwsxedc', 'zxcvbnm', 'asdfghjkl', 'starwars', 'superman', 'batman', 'hello123', 'freedom',
  'whatever', 'mustang', 'michael', 'jordan23', 'hunter2', 'pokemon', 'matrix', 'computer', 'internet', 'qwertyui',
  'gmail123', 'sunshine1',
]);
